export const isFileLessThan = (fileSize: number, maxFileSize: number) => {
  return fileSize < maxFileSize * 1024 * 1024;
};
